export default "__VITE_ASSET__Bsd8ng9e__"